import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import Alert from "@material-ui/lab/Alert";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { cloudFunctions } from "../../../firebase";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
  hidePostalCode: true,
};
const UpdatePaymentMethod = ({ currentUser }) => {
  const title = "Update Payment Method";
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [cardError, setCardError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const subcribe = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage(null);
    setSuccess(false);

    let hasError = false;
    let paymentMethodId = "";

    setCardError(null);

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      setCardError(error.message);
      hasError = true;
    } else {
      paymentMethodId = paymentMethod.id;
    }

    if (!hasError) {
      const updatePaymentMethod = cloudFunctions.httpsCallable(
        "updatePaymentMethod"
      );
      updatePaymentMethod({
        accountId: currentUser.uid,
        paymentMethodId: paymentMethodId,
      })
        .then((res) => {
          setSuccess(true);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          setErrorMessage(err.message);
        });
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 10000 }}>
        <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
      </Backdrop>
      <div className="container-fluid">
        <div className="animated fadeIn">
          <div className="card-deck mb-3">
            <div className="card">
              <div className="card-header text-center">{title}</div>
              <div className="card-body">
                <>
                  {success && (
                    <Alert type="success">
                      The payment method has been successfully updated.
                    </Alert>
                  )}
                  {errorMessage !== null && (
                    <Alert type="error">{errorMessage}</Alert>
                  )}
                  <div className="row justify-content-md-center">
                    <div className="col col-sm-12 col-md-8 col-lg-8 col-xl-6">
                      <div className="card-deck">
                        <div className="card mb-4">
                          <div className="card-header text-center">
                            Credit or debit card
                          </div>
                          <div className="card-body">
                            <div className="row justify-content-md-center">
                              <div className="col col-12">
                                {cardError !== null && (
                                  <Alert type="danger">{cardError}</Alert>
                                )}
                                <CardElement
                                  options={CARD_ELEMENT_OPTIONS}
                                ></CardElement>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-lg btn-block btn-primary"
                        disabled={loading ? true : false}
                        onClick={(e) => {
                          subcribe(e);
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatePaymentMethod;
